// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__nwuvX","rotate":"loader_rotate__iDyjp","dark":"loader_dark__tgjhC","light":"loader_light__oD_Lh"};